
import { useEffect } from 'react';

const ChatWidget = () => {
  useEffect(() => {
    // Function to load chat widget with error handling
    const loadChatWidget = () => {
      try {
        // Check if the script is already loaded
        if (document.querySelector('[data-widget-id="6866a6a1b1355f53f7c21a86"]')) {
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://widgets.leadconnectorhq.com/loader.js';
        script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
        script.setAttribute('data-widget-id', '6866a6a1b1355f53f7c21a86');
        script.async = true;
        
        script.onload = () => {
          console.log('Chat widget loaded successfully');
        };
        
        script.onerror = (error) => {
          console.log('Chat widget failed to load, continuing without it:', error);
        };
        
        document.head.appendChild(script);
      } catch (error) {
        console.log('Error loading chat widget:', error);
      }
    };

    // Store original WebSocket constructor
    const originalWebSocket = window.WebSocket;
    
    // Create custom WebSocket constructor that handles errors gracefully
    const CustomWebSocket = function(url: string | URL, protocols?: string | string[]) {
      const ws = new originalWebSocket(url, protocols);
      
      const originalOnError = ws.onerror;
      ws.onerror = function(error) {
        // Handle specific WebSocket errors that might be causing 412 errors
        if (url.toString().includes('lovableproject.com') || url.toString().includes('leadconnectorhq.com')) {
          console.log('WebSocket connection handled gracefully for:', url);
          return;
        }
        
        // Call original error handler for other WebSocket connections
        if (originalOnError) {
          originalOnError.call(ws, error);
        }
      };
      
      return ws;
    } as any;

    // Copy static properties
    CustomWebSocket.prototype = originalWebSocket.prototype;
    CustomWebSocket.CONNECTING = originalWebSocket.CONNECTING;
    CustomWebSocket.OPEN = originalWebSocket.OPEN;
    CustomWebSocket.CLOSING = originalWebSocket.CLOSING;
    CustomWebSocket.CLOSED = originalWebSocket.CLOSED;

    // Replace the global WebSocket constructor
    window.WebSocket = CustomWebSocket;

    // Load the chat widget after a short delay to ensure DOM is ready
    const timeoutId = setTimeout(loadChatWidget, 1000);

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      window.WebSocket = originalWebSocket;
    };
  }, []);

  return null;
};

export default ChatWidget;
